import type { FaireProductEntity } from "../../entity_types/product";

export const p_236hhz5fwt: FaireProductEntity = {
  token: "p_236hhz5fwt",
  type: "product",
  name: "S925 Silver 14k Gold Plated Twist Rope Zircon Ring",
  brandToken: "b_9a7m2r54fa",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/a554ac1e44dbfa97112a072fda46a95eb07b2ac7a3df8251078f28918d0fb965.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/221abb8f2709babfd4faf26ed03fc5a39328a81dbe92df70009d6c101798f47f.jpeg",
    "https://cdn.faire.com/fastly/259770e358f2a3345ed27beb6667ff755604757cd74404775706ed0e34cbd696.jpeg",
    "https://cdn.faire.com/fastly/da20284552282e1a170cd3c1d61fc76ed45de94abf6565dedbf04b86474a2a35.jpeg",
  ],
  priceDollars: 15.94,
  description:
    "-Meticulously crafted from premium sterling silver (S925), this ring embodies timeless elegance and artisanal craftsmanship, and let this handcrafted ring become a symbol of your refined taste and sophistication.\n-ID: GIORI24060\n-Material: S925 Silver\n-Stone(s): Cubic Zirconia\n-Size: 5,6,7,8 (Standard US Size)\n-Weight(s): 1g\n-Quality: Excellent\n-Lead Free, -Nickel Free",
  tags: [],
  msrpDollars: 31.87,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:27:13.813Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
